import React from "react";
import img from "../../images/blog/uno.jpg";
import { Link } from "react-router-dom";
const OtherPost = ({ otherpost }) => {
  return (
    <Link to={`/blog/${otherpost.postid}`}>
      <div className="blog_other-post">
        <div>
          <h4 className="other-post-title">{otherpost.posttitle}</h4>
          <p className="other-post-introduction">
            {`${otherpost.postsubtitle.slice(0, 20)}...`}
          </p>
        </div>

        <img
          src={otherpost.imagenes.principal}
          alt=""
          className="other-post-img"
        />
      </div>
    </Link>
  );
};

export default OtherPost;
